import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import CoachLayout from './CoachLayout';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function CoachShell() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API}/coaches/profile/me`, auth());
        setProfile(res.data);
      } catch {
        try {
          const created = await axios.post(`${API}/coaches/profile`, {}, auth());
          setProfile(created.data);
        } catch {
          setProfile(null);
        }
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const refreshProfile = async () => {
    try {
      const res = await axios.get(`${API}/coaches/profile/me`, auth());
      setProfile(res.data);
    } catch { /* noop */ }
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f4f6fa]" data-testid="coach-shell-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-teal-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <CoachLayout profile={profile}>
      <Outlet context={{ profile, refreshProfile }} />
    </CoachLayout>
  );
}
